import { page } from '../tracking-constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pageError = (data: any) => {
  const updatedData = {
    ...data,
    error: data.story.slug,
    errorType: `Error ${data.story.slug}`,
  };

  return ({
    event: 'pageError',
    timestamp: Math.floor(Date.now() / 1000),
    page: page(updatedData),
  });
};
